import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetAllQuestionsUseCaseInterface,
  GetQuestionByIdUseCaseInterface,
} from 'domain/usecases';

interface IQuestionsState {
  questions: GetAllQuestionsUseCaseInterface.Result;
  selectedQuestion: GetQuestionByIdUseCaseInterface.Result;
}

interface IPayloadQuestions
  extends PayloadAction<GetAllQuestionsUseCaseInterface.Result> {}

interface IPayloadSelectedQuestion
  extends PayloadAction<GetQuestionByIdUseCaseInterface.Result> {}

const initialState: IQuestionsState = {
  questions: [],
  selectedQuestion: null,
};

export const QuestionsSlice = createSlice({
  name: 'questions-slice',
  initialState,
  reducers: {
    loadQuestions: (state, action: IPayloadQuestions) => {
      state.questions = action.payload;
    },
    clearQuestions: (state) => {
      state.questions = [];
    },
    loadSelectedQuestion: (state, action: IPayloadSelectedQuestion) => {
      state.selectedQuestion = action.payload;
    },
    clearSelectedQuestion: (state) => {
      state.selectedQuestion = null;
    },
  },
});

export const {
  loadQuestions,
  clearQuestions,
  loadSelectedQuestion,
  clearSelectedQuestion,
} = QuestionsSlice.actions;

export default QuestionsSlice.reducer;
